import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChange, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from '../../../app/services/util.service';
import { AlertDialog } from '../dialogs/dialog';
import { HttpService } from '../../../app/services/http.service';

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfPreviewComponent implements OnChanges {
  @Input() url;
  @Input() attachmentName;
  extension;
  @Input() imgWidth = '650';
  @Input() imgHeight = '500px';
  @Input() downloadLink = false;
  baseUrl;
  tempUrl;
  urlInprogress;
  constructor(
    private domSanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private utilService: UtilService,
    private httpService: HttpService
  ) {}

  async ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['url'] && this.url) {
      await this.getBaseUrl(this.url);
      // this.tempUrl = this.getUrl(this.url);
      setTimeout(() => {
        this.cdRef.detectChanges();
      }, 3000);
    }
  }
  async getBaseUrl(url) {
    if (url) {
      const extension = url.split('.').pop();
      console.log(extension);
      // let image = this.extension === 'jpg' || this.extension === 'png' || this.extension === 'jpeg' || this.extension === 'JPG';
      // if (this.extension === 'pdf') {
      try {
        this.urlInprogress = true;
        let base64 = await this.utilService.getBase64StreamUsingS3(url);

        base64 = `data:image/jpg;base64,${base64}`;
        // if (extension === 'pdf') {
        //   base64 = `data:application/pdf;base64,${base64}`;
        // }
        this.baseUrl = base64;
        // Extract extension from MIME type in data URL (e.g., "data:image/png;base64,..." -> "png")
        this.extension = base64.split(';')[0].split('/')[1];
        this.urlInprogress = false;
        setTimeout(() => {
          this.cdRef.detectChanges();
        }, 1000);
      } catch (e) {
        this.urlInprogress = false;
      }
      setTimeout(() => {
        this.cdRef.detectChanges();
      }, 1000);
    }
  }
  getUrl(url) {
    if (url) {
      let image = this.extension === 'jpg' || this.extension === 'png' || this.extension === 'jpeg' || this.extension === 'JPG';
      // let securl = this.domSanitizer.bypassSecurityTrustResourceUrl('https://docs.google.com/gview?url=' + url + '&embedded=true');
      setTimeout(() => {
        this.cdRef.detectChanges();
      }, 1000);
      return (
        (image && image) || this.domSanitizer.bypassSecurityTrustResourceUrl('https://docs.google.com/gview?url=' + url + '&embedded=true')
      );
    }
  }
  async downloadAttachment(attachment: any): Promise<void> {
    const extension = attachment.split('.').pop();
    // const res = await this.utilService.downloadFile({ s3Url: this.url });
    console.log(this.httpService.baseApiUrl + this.httpService.baseApiPath);
    const res = await fetch(this.httpService.baseApiUrl + this.httpService.baseApiPath + '/media/download', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        s3Url: attachment,
      }),
    });

    const blob = await res.blob();
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = (this.attachmentName || 'document') + '.' + extension;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
  // const file = await this.utilService.downloadFile({ s3Url: this.url });
}
